  $( document ).ready(function() {  
//Gloabal variable 
    var var_id=''
    var qty=''

//Open Quick-view Drawer    
  $('.img-quick-view-btn .js-menu__open').on('click', function(){
    $('.js-menu__context').show()
    $("body").addClass("drawer-hidden");
    
    $('.qv-product-images').removeClass("slick-initialized slick-slider").empty();
    $('.qv-product_slider-nav').removeClass("slick-initialized slick-slider slick-dotted").empty();
    $('.qv-add-to-cart-response').removeClass("slick-initialized slick-slider slick-dotted").empty();
      var product_handle = $(this).attr('handle');
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        var title = product.title;
        var p_handle = product.handle;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var desc = product.description;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        $('.qv-product-title').text(title);
        $('.qv-product-type').text(type);
        $('.qv-product-description').html(desc);
        $('.view-product').attr('href', url);
        var imageCount = $(images).length;
        $('.product-details-bt').attr('href', url);
        // image load and append in slick slider 
        $(images).each(function (i, image) {
          $('.qv-product-images').append('<div><img src="' + image + '"></div>');
          $('.qv-product_slider-nav').append('<div><img src="' + image + '"></div>');
        });

      $(options).each(function (i, option) {

        var opt = option.name;

        var selectClass = '.option.' + opt.toLowerCase();

        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');

        $(option.values).each(function (i, value) {

          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '"  class="show_option_variant">' + value + '</option>');

        });

      });

       $('.option-selection-size select').on("change",function() {
          var selectedOption =  $(this).find(":selected").val(); 
          var selectedVariant = findVariantByOption(selectedOption);
      
          if (selectedVariant) {
              var_id = selectedVariant.id;
              var price = parseFloat(selectedVariant.price / 100).toFixed(2);
              var original_price = parseFloat(selectedVariant.compare_at_price / 100).toFixed(2);
              $("#main-nav .qv-product-price").text("$"+price);
          }
      });

      $('.js-menu__close').on("click",function() {
        $('.qv-product-options').empty();
      });
        
        function findVariantByOption(selectedOption) {
            var selectedVariant = null;
        
            // Iterate through variants to find the one with the matching option
            $(product.variants).each(function(i, variant) {
                var variantOption = variant.options[0]; // Assuming single-option variants
                if (variantOption === selectedOption ) {
                    selectedVariant = variant;
                    return false; // Exit the loop early
                }
            });
        
            return selectedVariant;
        }

        var selectedVar = null;
        
        $(product.variants).each(function (i, v) {
            if (v.available) {
                selectedVar = v;
                return false; // Exit the loop early
            }
        });
        
        if (selectedVar) {
            var selectedOptionn = selectedVar.options[0];
            $('.option').val(selectedOptionn).trigger('change');
            //var_id = selectedVar.id;     
        }


        var showAddToCartButton = false; // Flag to determine whether to show the Add to Cart button
        
        $(product.variants).each(function (i, v) {
   
          // variants_id set in variable
         // var_id = v.id;

          var variantOption = v.options; // Assuming single-option variants

          // Show price 
          if (v.available == false) {
            $('.option').find('option[value="' + variantOption + '"]').prop('disabled', true);
            $('.custom_hide').hide();
            $('.sold-out').prop('disabled', true).text('Sold Out').show();
          } else {
            // Set the flag to true if at least one variant is available
            showAddToCartButton = true;
        
            $('.add-to-cart').show();
            $('.sold-out').hide();
            // price = parseFloat(v.price / 100).toFixed(2);
            // original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            // $('.qv-product-price').text('$' + price);
            // if (original_price > 0) {
            //   $('.qv-product-original-price').text('$' + original_price).show();
            // } else {
            //   $('.qv-product-original-price').hide();
            // }
          }
        });
        
        // Show the Add to Cart button if at least one variant is available
        if (showAddToCartButton) {
          $('.add-to-cart').show();
          $('.sold-out').hide();
        }

      });
      var menu = $(this).attr('data-menu');
      $(menu).toggleClass('js-menu__expanded');
      $(menu).parent().toggleClass('js-menu__expanded');
      // setTimeout(function() {
      //    $('.qv-product-images').not('.slick-initialized').slick({
      //       slidesToShow: 1,
      //       infinite: false,
      //       slidesToScroll: 1,
      //       arrows: true,
      //       fade: true,
      //       asNavFor: '.qv-product_slider-nav'
      //     }); 
      //     $('.qv-product_slider-nav').not('.slick-initialized').slick({
      //       slidesToShow: 3,
      //       infinite: true,
      //       slidesToScroll: 1,
      //       asNavFor: '.qv-product-images',
      //       dots: true,
      //       focusOnSelect: true,
      //       responsive: [
      //         {
      //           breakpoint: 990,
      //           settings: {
      //             slidesToShow: 3,
      //             slidesToScroll: 1
      //           }
      //         },
      //         {
      //           breakpoint: 480,
      //           settings: {
      //             slidesToShow: 2,
      //             slidesToScroll: 1
      //           }
      //         }]
      //     });  
      //  }, 1000);
});


//quantity add-remove function     
  $('.qtybox .btnqty').on("click",function() {          
     qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
          if($(this).hasClass('qtyplus')) {
          qty++;
          }else {
          if(qty > 1) {
          qty--;
          }
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);
   });
     
//ADD to Card Functionlity
  $('.add-to-cart').on("click",function() {
    jQuery.post('/cart/add.js', {quantity: qty,id: var_id,},null,"json").done(function (data) {
    $('.cart-link').load(' .cart-link')
    $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
    }).fail(function ($xhr) {
    var data = $xhr.responseJSON;
    $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
    });
  })


//Close quick-view-Drawer    
  $('.js-menu__context, .js-menu__close').on('touchend click', function(event){
     $("body").removeClass("drawer-hidden");
        if ( $(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close') ) {
             $('.js-menu__expanded').removeClass('js-menu__expanded');
        }
});     
});